import React, { FC, ReactNode } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Layouts } from 'components';

interface IProps {
  header: ReactNode;
  tabs: ReactNode;
  body: ReactNode;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  tabs: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

const Layout: FC<IProps> = ({ header, tabs, body, children }) => {
  const classes = useStyles();

  function renderMain() {
    return (
      <Grid container direction="column" spacing={2}>
        {header}
        <Grid item container direction="column" wrap="nowrap">
          <Grid item xs>
            <Paper variant="outlined" className={classes.tabs}>
              {tabs}
            </Paper>
          </Grid>
          <Grid item xs>
            {body}
          </Grid>
        </Grid>
        {children}
      </Grid>
    );
  }

  return (
    <div className={classes.root}>
      <Layouts.App1Column desktopSize={8} main={renderMain()} />
    </div>
  );
};

export default Layout;
